import { useState, useEffect } from 'react';
import LanguagesTable from './LanguagesTable';
import useModal from '../../../hooks/useModal';
import useTableService from './useTableService';
import AddModal from './add-modal-form/AddModal';
import icons from '../../../helpers/iconMenu.js';
import useValidateTable from './useValidateTable';
import Icon from '../../../components/icon-component/Icon';
import Text from '../../../components/text-component/Text';
import { getStaticText } from '../../../lables/lablesService';
import Button from '../../../components/button-component/Button';
import Modal, { ModalContent, ModalHeader } from '../../../components/modal-component/Modal';
import LanguageWrapper, { LanguageWrapperHeader, LanguageWrapperMain } from '../../../components/language-wrapper/LanguageWrapper';

/**
 * The parent component of the language
 * 
 * @returns JSX
 */
const LanguagesList = () => {
    //Custom modal hook
    const { isOpen, toggle } = useModal();
    //Data form table service
    const { ...allDataTable } = useTableService();
    //State for mount component
    const [didMount, setDidMount] = useState(false);
    //Custom validation hook
    const { errors, handleValidation } = useValidateTable();

    useEffect(() => {
        setDidMount(true);
        return () => setDidMount(false);
    }, [])

    if (!didMount) {
        return null;
    }

    return (
        <LanguageWrapper>

            <LanguageWrapperHeader>
                <Text
                    text_style={"h2"}
                    content={getStaticText('lng_page_title')}
                />
                <Text
                    text_style={"h5 text-danger"}
                    content={allDataTable.respError}
                />
            </LanguageWrapperHeader>

            <LanguageWrapperMain>

                {
                    isOpen && <div className="overlay text-center">

                        <div className='d-flex justify-content-center'>
                            <Modal modalClass="modal_language" isOpen={isOpen}>
                                <ModalHeader modalHeaderClass="pt-4">
                                    <Text
                                        content={getStaticText('lng_form_title')}
                                        text_style={"text-center text-danger h5"}
                                    >
                                        <Icon
                                            onClick={toggle}
                                            icon_style={icons.lng_form_remove}
                                            icon_className={"lng_icon_remove"}
                                        />
                                    </Text>
                                </ModalHeader>
                                <ModalContent modalContent="text-center">
                                    <AddModal
                                        toggle={toggle}
                                        errors={errors}
                                        dataTable={allDataTable.dataTable}
                                        handleValidation={handleValidation}
                                        addRowsValue={allDataTable.addRowsValue}
                                        setDataTable={allDataTable.setDataTable}
                                        fetchPageList={allDataTable.fetchPageList}
                                        successfulMsg={allDataTable.successfulMsg}
                                        unsuccessfulMsg={allDataTable.unsuccessfulMsg}
                                        setSuccessfulMsg={allDataTable.setSuccessfulMsg}
                                        setUnsuccessfulMsg={allDataTable.setUnsuccessfulMsg}
                                    />
                                </ModalContent>
                            </Modal>
                        </div>

                    </div>
                }

                <div className="d-flex justify-content-end pt-2 pb-2">
                    <Button
                        onClick={toggle}
                        bgcolor={"info"}
                        label={getStaticText('btn_add_lng')}
                        btn_styles={"btn-active shadow-none text-white"}
                    />
                </div>

                <div>
                    <LanguagesTable
                        errors={errors}
                        pages={allDataTable.allPage}
                        loading={allDataTable.loading}
                        dataTable={allDataTable.dataTable}
                        handleValidation={handleValidation}
                        currentPage={allDataTable.currentPage}
                        setDataTable={allDataTable.setDataTable}
                        successfulMsg={allDataTable.successfulMsg}
                        fetchPageList={allDataTable.fetchPageList}
                        updateRowValue={allDataTable.updateRowValue}
                        setCurrentPage={allDataTable.setCurrentPage}
                        handleSortRows={allDataTable.handleSortRows}
                        unsuccessfulMsg={allDataTable.unsuccessfulMsg}
                        successfulUpdateMsg={allDataTable.successfulUpdateMsg}
                        fetchPageListSortIso={allDataTable.fetchPageListSortIso}
                        unsuccessfulUpdateMsg={allDataTable.unsuccessfulUpdateMsg}
                        fetchPageListSortName={allDataTable.fetchPageListSortName}
                        fetchPageListSortFlag={allDataTable.fetchPageListSortFlag}
                        setSuccessUpdatefulMsg={allDataTable.setSuccessUpdatefulMsg}
                        setUnsuccessfulUpdateMsg={allDataTable.setUnsuccessfulUpdateMsg}
                        fetchPageListSortIsDefault={allDataTable.fetchPageListSortIsDefault}
                    />
                </div>

            </LanguageWrapperMain>

        </LanguageWrapper>
    )
}

export default LanguagesList;